import { HOST } from '../config';
import { apiGet, apiGetNoErrorHandler, apiPost, apiPut } from '../api';

export const A = {
  REQUEST_SIGNIN: 'REQUEST_SIGNIN',
  RECEIVE_SIGNIN: 'RECEIVE_SIGNIN',
  ERROR_SIGNIN: 'ERROR_SIGNIN',

  REQUEST_SIGNUP: 'REQUEST_SIGNUP',
  RECEIVE_SIGNUP: 'RECEIVE_SIGNUP',
  ERROR_SIGNUP: 'ERROR_SIGNUP',

  REQUEST_FORGOT: 'REQUEST_FORGOT',
  RECEIVE_FORGOT: 'RECEIVE_FORGOT',
  ERROR_FORGOT: 'ERROR_FORGOT',

  REQUEST_RECOVERY: 'REQUEST_RECOVERY',
  RECEIVE_RECOVERY: 'RECEIVE_RECOVERY',
  ERROR_RECOVERY: 'ERROR_RECOVERY',

  REQUEST_ACTIVATE_ACCOUNT: 'REQUEST_ACTIVATE_ACCOUNT',
  RECEIVE_ACTIVATE_ACCOUNT: 'RECEIVE_ACTIVATE_ACCOUNT',
  ERROR_ACTIVATE_ACCOUNT: 'ERROR_ACTIVATE_ACCOUNT',

  REQUEST_GET_ACCOUNT_INFO: 'REQUEST_GET_ACCOUNT_INFO',
  RECEIVE_GET_ACCOUNT_INFO: 'RECEIVE_GET_ACCOUNT_INFO',
  ERROR_GET_ACCOUNT_INFO: 'ERROR_GET_ACCOUNT_INFO',

  REQUEST_POST_ACCOUNT_INFO: 'REQUEST_POST_ACCOUNT_INFO',
  RECEIVE_POST_ACCOUNT_INFO: 'RECEIVE_POST_ACCOUNT_INFO',
  ERROR_POST_ACCOUNT_INFO: 'ERROR_POST_ACCOUNT_INFO',

  REQUEST_CHANGE_PASSWORD: 'REQUEST_CHANGE_PASSWORD',
  RECEIVE_CHANGE_PASSWORD: 'RECEIVE_CHANGE_PASSWORD',
  ERROR_CHANGE_PASSWORD: 'ERROR_CHANGE_PASSWORD',

  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  SET_PRIVILEGES: 'SET_PRIVILEGES',

  LOGOUT: 'LOGOUT',

  REQUEST_EXPIRATION_DAYS_CALCULATE_BATCH: 'REQUEST_EXPIRATION_DAYS_CALCULATE_BATCH',
  RECEIVE_EXPIRATION_DAYS_CALCULATE_BATCH: 'RECEIVE_EXPIRATION_DAYS_CALCULATE_BATCH',
  ERROR_EXPIRATION_DAYS_CALCULATE_BATCH: 'ERROR_EXPIRATION_DAYS_CALCULATE_BATCH',

  REQUEST_EXPIRATION_DAYS_CALCULATE: 'REQUEST_EXPIRATION_DAYS_CALCULATE',
  RECEIVE_EXPIRATION_DAYS_CALCULATE: 'RECEIVE_EXPIRATION_DAYS_CALCULATE',
  ERROR_EXPIRATION_DAYS_CALCULATE: 'ERROR_EXPIRATION_DAYS_CALCULATE',

  TOGGLE_ADMIN_PANEL: 'TOGGLE_ADMIN_PANEL',
};

export const fetchSignIn = (data, redirect) => {
  return (dispatch) => {
    dispatch(requestSignIn());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/auth',
        body: data,
        errorException: { 401: 'Указаны неверный логин или пароль' },
        customHeaders: redirect ? { kak2c_token_extended: true } : null,
        callback: (res) => {
          localStorage.setItem('admin', res.admin);
          dispatch(receiveSignIn(res));
          resolve(res);
        },
        error: (err) => {
          dispatch(errorSignIn(err));
          reject(err);
        },
      });
    });
  };
};

const requestSignIn = () => {
  return {
    type: A.REQUEST_SIGNIN,
  };
};

const receiveSignIn = (data) => {
  return {
    type: A.RECEIVE_SIGNIN,
    data,
  };
};

const errorSignIn = (err) => {
  return {
    type: A.ERROR_SIGNIN,
    err,
  };
};

export const fetchSignUp = (data) => {
  return (dispatch) => {
    dispatch(requestSignUp());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/pub/register',
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveSignUp(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorSignUp(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorSignUp(err));
          reject(err);
        },
      });
    });
  };
};

const requestSignUp = () => {
  return {
    type: A.REQUEST_SIGNUP,
  };
};

const receiveSignUp = (data) => {
  return {
    type: A.RECEIVE_SIGNUP,
    data,
  };
};

const errorSignUp = (err) => {
  return {
    type: A.ERROR_SIGNUP,
    err,
  };
};

export const fetchActivateAccount = (tokens) => {
  return (dispatch) => {
    dispatch(requestActivateAccount());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/registration_init',
        tokens,
        callback: (res) => {
          dispatch(receiveActivateAccount(res));
          localStorage.setItem(
            'Kak2cTokenData',
            JSON.stringify({ access_token: tokens.access_token }),
          );
          dispatch(setAuthToken({ access_token: tokens.access_token }));
          localStorage.setItem('Kak2cPrivileges', JSON.stringify(['ADMIN']));
          dispatch(setPrivileges(['ADMIN']));
          resolve();
        },
        error: (err) => {
          dispatch(errorActivateAccount(err));
          reject(err);
        },
      });
    });
  };
};

const requestActivateAccount = () => {
  return {
    type: A.REQUEST_ACTIVATE_ACCOUNT,
  };
};

const receiveActivateAccount = (data) => {
  return {
    type: A.RECEIVE_ACTIVATE_ACCOUNT,
    data,
  };
};

const errorActivateAccount = (err) => {
  return {
    type: A.ERROR_ACTIVATE_ACCOUNT,
    err,
  };
};

export const fetchForgot = (data) => {
  return (dispatch) => {
    dispatch(requestForgot());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/pub/password_reset',
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveForgot(res));
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorForgot(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorForgot(err));
          reject(err);
        },
      });
    });
  };
};

const requestForgot = () => {
  return {
    type: A.REQUEST_FORGOT,
  };
};

const receiveForgot = (data) => {
  return {
    type: A.RECEIVE_FORGOT,
    data,
  };
};

const errorForgot = (err) => {
  return {
    type: A.ERROR_FORGOT,
    err,
  };
};

export const fetchRecovery = (data) => {
  return (dispatch) => {
    dispatch(requestRecovery());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/pub/password_reset_confirm',
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveRecovery(res));
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRecovery(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRecovery(err));
          reject(err);
        },
      });
    });
  };
};

const requestRecovery = () => {
  return {
    type: A.REQUEST_RECOVERY,
  };
};

const receiveRecovery = (data) => {
  return {
    type: A.RECEIVE_RECOVERY,
    data,
  };
};

const errorRecovery = (err) => {
  return {
    type: A.ERROR_RECOVERY,
    err,
  };
};

export const setAuthToken = (data) => {
  return {
    type: A.SET_AUTH_TOKEN,
    data,
  };
};

export const setPrivileges = (data) => {
  return {
    type: A.SET_PRIVILEGES,
    data,
  };
};

export const logout = () => {
  localStorage.removeItem('Kak2cTokenData');
  localStorage.removeItem('Kak2cSavedState');
  localStorage.removeItem('Kak2cPrivileges');
  localStorage.removeItem('admin');
  localStorage.removeItem('adminPanel');
  window.location.replace('/');
  return {
    type: A.LOGOUT,
  };
};

export const fetchGetAccountInfo = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAccountInfo());
    return apiGet({
      url: HOST + '/api/lite/account_info',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetAccountInfo(res));
        } else {
          dispatch(errorGetAccountInfo('Ошибка получения аккаунта'));
        }
      },
      error: (err) => {
        dispatch(errorGetAccountInfo(err));
      },
    });
  };
};

const requestGetAccountInfo = () => {
  return {
    type: A.REQUEST_GET_ACCOUNT_INFO,
  };
};

const receiveGetAccountInfo = (data) => {
  return {
    type: A.RECEIVE_GET_ACCOUNT_INFO,
    data,
  };
};

const errorGetAccountInfo = (err) => {
  return {
    type: A.ERROR_GET_ACCOUNT_INFO,
    err,
  };
};

export const fetchPostAccountInfo = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostAccountInfo());
    return apiPost({
      url: HOST + '/api/lite/account_info',
      tokens: getState().auth.tokenData,
      body: data,
      callback: (res) => {
        if (res.success) {
          dispatch(receivePostAccountInfo(res));
        } else {
          dispatch(errorPostAccountInfo('Ошибка получения аккаунта'));
        }
      },
      error: (err) => {
        dispatch(errorPostAccountInfo(err));
      },
    });
  };
};

const requestPostAccountInfo = () => {
  return {
    type: A.REQUEST_POST_ACCOUNT_INFO,
  };
};

const receivePostAccountInfo = (data) => {
  return {
    type: A.RECEIVE_POST_ACCOUNT_INFO,
    data,
  };
};

const errorPostAccountInfo = (err) => {
  return {
    type: A.ERROR_POST_ACCOUNT_INFO,
    err,
  };
};

export const fetchChangePassword = (data, tokens) => {
  return (dispatch) => {
    dispatch(requestChangePassword());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/settings/users/password',
        body: data,
        tokens,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveChangePassword(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorChangePassword(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorChangePassword(err));
          reject(err);
        },
      });
    });
  };
};

const requestChangePassword = () => {
  return {
    type: A.REQUEST_CHANGE_PASSWORD,
  };
};

const receiveChangePassword = (data) => {
  return {
    type: A.RECEIVE_CHANGE_PASSWORD,
    data,
  };
};

const errorChangePassword = (err) => {
  return {
    type: A.ERROR_CHANGE_PASSWORD,
    err,
  };
};

export const fetchGetBitrixLeedAuth = ({
  title,
  email,
  phone,
  promocode,
  sourceId,
  UTMSource,
  UTMMedium,
  UTMCampaign,
  UTMContent,
}) => {
  return (dispatch, getState) => {
    let url = `https://kak2c.bitrix24.ru/rest/66/zurmp5lxef7rwvvw/crm.lead.add.json?FIELDS[TITLE]=${title}&FIELDS[EMAIL][0][VALUE]=${email}&FIELDS[PHONE][0][VALUE]=${phone}`;
    if (promocode) {
      url += `&FIELDS[UF_CRM_1642770778954]=${promocode}`;
    }
    if (sourceId) {
      url += `&FIELDS[SOURCE_ID]=${sourceId}`;
    }
    if (UTMSource) {
      url += `&FIELDS[UTM_SOURCE]=${UTMSource}`;
    }
    if (UTMMedium) {
      url += `&FIELDS[UTM_MEDIUM]=${UTMMedium}`;
    }
    if (UTMCampaign) {
      url += `&FIELDS[UTM_CAMPAIGN]=${UTMCampaign}`;
    }
    if (UTMContent) {
      url += `&FIELDS[UTM_CONTENT]=${UTMContent}`;
    }

    return apiGetNoErrorHandler({
      url: url,
      tokens: getState().auth.tokenData,
      withoutKak2cAHeader: true,
      callback: (res) => {
        console.log('Передача в битрикс прошла успешно');
      },
      timeout: 1000,
    });
  };
};

export const fetchExpirationDaysCalculateBatch = (data, tokens) => {
  return (dispatch) => {
    dispatch(requestExpirationDaysCalculateBatch());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/expiration/days/calculate/batch',
        body: data,
        tokens,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveExpirationDaysCalculateBatch(res.result));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorExpirationDaysCalculateBatch(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorExpirationDaysCalculateBatch(err));
          reject(err);
        },
      });
    });
  };
};

const requestExpirationDaysCalculateBatch = () => {
  return {
    type: A.REQUEST_EXPIRATION_DAYS_CALCULATE_BATCH,
  };
};

const receiveExpirationDaysCalculateBatch = (data) => {
  return {
    type: A.RECEIVE_EXPIRATION_DAYS_CALCULATE_BATCH,
    data,
  };
};

const errorExpirationDaysCalculateBatch = (err) => {
  return {
    type: A.ERROR_EXPIRATION_DAYS_CALCULATE_BATCH,
    err,
  };
};

export const fetchExpirationDaysCalculate = (data, tokens) => {
  return (dispatch) => {
    dispatch(requestExpirationDaysCalculate());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/expiration/days/calculate',
        body: data,
        tokens,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveExpirationDaysCalculate(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorExpirationDaysCalculate(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorExpirationDaysCalculate(err));
          reject(err);
        },
      });
    });
  };
};

const requestExpirationDaysCalculate = () => {
  return {
    type: A.REQUEST_EXPIRATION_DAYS_CALCULATE,
  };
};

const receiveExpirationDaysCalculate = (data) => {
  return {
    type: A.RECEIVE_EXPIRATION_DAYS_CALCULATE,
    data,
  };
};

const errorExpirationDaysCalculate = (err) => {
  return {
    type: A.ERROR_EXPIRATION_DAYS_CALCULATE,
    err,
  };
};

export const toggleAdminPanel = (data) => {
  return {
    type: A.TOGGLE_ADMIN_PANEL,
    data,
  };
};

export const fetchToggleAdminPanel = (data) => {
  return (dispatch) => {
    dispatch(toggleAdminPanel(data));
    localStorage.setItem('adminPanel', data);
  };
};
